<template>
    <div>
        <h2 v-on:click="toggle()">
            <i :class="'fa fa-caret-' + (this.isOpen ? 'down' : 'right')"></i>
            {{ title }}
        </h2>
        <div v-if="isOpen">
            <slot></slot>
        </div>
    </div>
</template>

<script>
  export default {
    props: ['title', 'default'],
    data() {
      return {
        isOpen: false
      }
    },
    methods: {
      toggle() {
        this.isOpen = !this.isOpen
      }
    },
    mounted() {
      this.default === 'open' ? this.isOpen = true : this.isOpen = false
    }
  }
</script>
